<ng-template class="theme-modal" #quickView let-modal>
    <div class="modal-content quick-view-modal">
        <div class="modal-body">
            <button type="button" class="close float-end border-0" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="row">
                <div class="col-lg-6  col-xs-12">
                    <div class="quick-view-img">
                        <img [src]="env.mediaUrl+(ImageSrc ? ImageSrc : product.ImgName.split(',')[0])" [alt]="product.ImgName.split(',')[0]" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-6 rtl-text">
                    <div class="product-right">
                        <h2 translate>{{ product.ItemName | titlecase }}</h2>
                        <h3 translate class="price">{{ product.SellRate * currency?.price | currency:currency?.currency:'symbol' }}
                            <del *ngIf="product?.MrpRate"><span class="money price">{{ product.MrpRate * currency?.price | currency:currency?.currency:'symbol' }}</span></del>
                        </h3>
                        <ul class="color-variant" *ngIf="Color(product.ItemFrontAttributes).length">
                            <li [class]="color" *ngFor="let color of Color(product.ItemFrontAttributes)"
                                [ngStyle]="{'background-color': color}" (click)="ChangeVariants(color, product)">
                            </li>
                        </ul>
                    <div class="border-product">
                            <h6 class="product-title">product details</h6>
                            <p [innerHTML]="product?.LongDescription"></p>
                        </div>
                        <div class="product-description border-product">
                            <div class="size-box" *ngIf="Size(product.ItemFrontAttributes).length">
                                <ul>
                                    <li *ngFor="let size of Size(product.ItemFrontAttributes)">
                                        <a href="javascript:void(0)">{{ size | titlecase }}</a>
                                    </li>
                                </ul>
                            </div>
                            <h5 class="avalibility" *ngIf="counter <= product.SellRate"><span translate>In Stock</span></h5>
                            <h5 class="avalibility" *ngIf="counter > product.SellRate"><span translate>Out of Stock</span></h5>
                            <h6 class="product-title">quantity</h6>
                            <div class="qty-box">
                                <div class="input-group">
                                    <span class="input-group-prepend">
                                        <button type="button" class="btn quantity-left-minus" data-type="minus" (click)="decrement()">
                                            <i class="ti-angle-left"></i>
                                        </button>
                                    </span>
                                    <input type="text" name="quantity" class="form-control input-number"  [value]="counter" disabled>
                                    <span class="input-group-prepend">
                                        <button type="button" class="btn quantity-right-plus" data-type="plus" (click)="increment()">
                                            <i class="ti-angle-right"></i>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="product-buttons">
                            <a href="javascript:void(0)" class="btn btn-solid" [class.disabled]="counter > 0" (click)="addToCart(product)">add to cart</a>
                            <a [routerLink]="['/products/', product.ItemUrlName]" class="btn btn-solid">view detail</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>